/* eslint-disable @typescript-eslint/no-explicit-any */
import dayjs from 'dayjs';

function getNestedValue(obj: any, path: string): any {
  return path.split('.').reduce((acc, key) => (acc != null ? acc[key] : undefined), obj);
}

export function countWhenFieldEquals(
  array: Array<any>,
  fieldToCheck: string,
  valueToCheck: string | number,
): number | null {
  if (!Array.isArray(array)) return null;
  let count = 0;
  array.forEach((item) => {
    if (getNestedValue(item, fieldToCheck) === valueToCheck) {
      count++;
    }
  });
  return count;
}

export function countWhenAllFieldsEqual(
  array: Array<any>,
  ...fieldValuePairs: [string, any][]
): number | null {
  if (!Array.isArray(array)) return null;
  return array.filter((item) =>
    fieldValuePairs.every(([field, value]) => getNestedValue(item, field) === value),
  ).length;
}

export function countWhenFieldNotEquals(
  array: Array<any>,
  fieldToCheck: string,
  valueToCheck: string | number,
): number | null {
  if (!Array.isArray(array)) return null;
  let count = 0;
  array.forEach((item) => {
    if (getNestedValue(item, fieldToCheck) !== valueToCheck) {
      count++;
    }
  });
  return count;
}

export function countWhenFieldNumberGreaterThan(
  array: Array<any>,
  fieldToCheck: string,
  valueToCheck: number,
): number | null {
  if (!Array.isArray(array)) return null;
  let count = 0;
  array.forEach((item) => {
    if (Number(getNestedValue(item, fieldToCheck)) > valueToCheck) {
      count++;
    }
  });
  return count;
}

export function countWhenFieldNumberLessThan(
  array: Array<any>,
  fieldToCheck: string,
  valueToCheck: number,
): number | null {
  if (!Array.isArray(array)) return null;
  let count = 0;
  array.forEach((item) => {
    if (Number(getNestedValue(item, fieldToCheck)) < valueToCheck) {
      count++;
    }
  });
  return count;
}

export function countWhenFieldDateBefore(
  array: Array<any>,
  fieldToCheck: string,
  dateToCheck: Date,
): number | null {
  if (!Array.isArray(array)) return null;
  let count = 0;
  array.forEach((item) => {
    const itemDate = dayjs(getNestedValue(item, fieldToCheck));
    if (itemDate.isBefore(dateToCheck)) {
      count++;
    }
  });
  return count;
}

export function countWhenFieldDateAfter(
  array: Array<any>,
  fieldToCheck: string,
  dateToCheck: Date,
): number | null {
  if (!Array.isArray(array)) return null;
  let count = 0;
  array.forEach((item) => {
    const itemDate = dayjs(getNestedValue(item, fieldToCheck));
    if (itemDate.isAfter(dateToCheck)) {
      count++;
    }
  });
  return count;
}

export function hasUnreadNotifications(notifications: Array<any>): boolean {
  if (!Array.isArray(notifications)) return false;
  return notifications.some((notification) => !notification?.read);
}
